import React from 'react';
import { FormItemLabelName, FormItemType } from '@framework/workbench/drawer/constants';
import i18n from '@i18next/i18n';
import { LINEAR_GRADIENT_ICON, RADIAL_GRADIENT_ICON } from '@src/framework/workbench/drawer/image';
import { OpacityOptions, AngleOptions } from '@framework/workbench/drawer/common/config';
import { ChartFormItemKey } from '@tencent/chart-drawer-components/lib/schema';
import { FillType, textStyle } from '@framework/workbench/drawer/ui/fill/constants';
import { DirectList } from '@src/framework/editor/src/js/constants';
import type { FormConfig } from '@tencent/wb-ext-form';

// 填充方式
export const FillTypes = [
    { key: FillType.NO_FILL, content: i18n.t('无填充') },
    { key: FillType.SOLID_FILL, content: i18n.t('纯色填充') },
    { key: FillType.GRADUAL_FILL, content: i18n.t('渐变填充') },
    { key: FillType.IMAGE_FILL, content: i18n.t('图片填充') },
    { key: FillType.PATT_FILL, content: i18n.t('图案填充') },
];

// 过滤掉 '从正下方' 和 '从正上方'
export const DirectOptions = DirectList.filter(item => item.id !== 'bottomTop' && item.id !== 'topBottom').map((item: any) => {
    item.key = item;
    item.content = item.title;
    return item;
});


export const FORM_CONFIGS: FormConfig[] = [
    {
        type: FormItemType.SELECT,
        name: ChartFormItemKey.CHART_FILL_SELECT,
        options: {
            selectOptions: FillTypes,
        },
    },
    {
        type: FormItemType.CUSTOM,
        name: ChartFormItemKey.CHART_SOLID_FILL_COLOR,
        style: {
            boxSizing: 'content-box',
            maxHeight: 28,
        },
    },
    {
        type: FormItemType.SLIDER,
        name: ChartFormItemKey.CHART_SOLID_FILL_OPACITY,
        label: FormItemLabelName.OPACITY,
        options: {
            ...OpacityOptions,
        },
        defaultValue: 0,
    },
    {
        type: FormItemType.BUTTON,
        name: ChartFormItemKey.CHART_GRADUAL_FILL_LINEAR_GRADIENT,
        options: {
            icon: <img src={LINEAR_GRADIENT_ICON} alt={''} style={{ margin: '-1px' }}/>,
        },
        tooltip: i18n.t('线性渐变'),
        style: {
            maxWidth: 36,
        },
    },
    {
        type: FormItemType.BUTTON,
        name: ChartFormItemKey.CHART_GRADUAL_FILL_RADIAL_GRADIENT,
        options: {
            icon: <img src={RADIAL_GRADIENT_ICON} alt={''} style={{ margin: '-1px' }}/>,
        },
        tooltip: i18n.t('径向渐变'),
        style: {
            maxWidth: 36,
        },
    },
    {
        type: FormItemType.ANGLE,
        name: ChartFormItemKey.CHART_GRADUAL_FILL_ANGLE,
        options: {
            ...AngleOptions,
            maxLength: 4,
        },
        style: {
            minWidth: 116,
        },
        defaultValue: 0,
    },
    {
        type: FormItemType.SELECT,
        name: ChartFormItemKey.CHART_GRADUAL_FILL_DIRECTION,
        // @ts-ignore
        options: {
            selectOptions: DirectOptions,
            style: {
                fontSize: 12,
            },
        },
        style: {
            minWidth: 116,
        },
        tooltip: i18n.t('方向'),
    },
    {
        type: FormItemType.CUSTOM,
        name: ChartFormItemKey.CHART_GRADUAL_FILL_BAR,
        content: '',
    },
    {
        type: FormItemType.SLIDER,
        name: ChartFormItemKey.CHART_GRADUAL_FILL_OPACITY,
        label: FormItemLabelName.OPACITY,
        options: {
            ...OpacityOptions,
        },
        defaultValue: 0,
    },
    {
        name: ChartFormItemKey.CHART_GRADUAL_FILL_TYPE_TEXT,
        type: FormItemType.TEXT,
        value: i18n.t('类型'),
        style: textStyle,
    },
    {
        name: ChartFormItemKey.CHART_GRADUAL_FILL_DIRECTION_TEXT,
        type: FormItemType.TEXT,
        value: i18n.t('方向'),
        style: textStyle,
    },
    {
        name: ChartFormItemKey.CHART_GRADUAL_FILL_ANGLE_TEXT,
        type: FormItemType.TEXT,
        value: i18n.t('角度'),
        style: textStyle,
    },
];
